import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { APP_ROUTES } from '../config/api.config';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  padding: 20px;
`;

const ErrorCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.5s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Icon = styled.div`
  color: #dc3545;
  font-size: 64px;
  margin-bottom: 24px;
  animation: scaleIn 0.5s ease-out;

  @keyframes scaleIn {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }
`;

const Title = styled.h1`
  color: #dc3545;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
`;

const Subtitle = styled.h2`
  color: #4b5563;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
`;

const Message = styled.p`
  color: #6b7280;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 12px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
    color: white;
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
    }
  ` : `
    background: white;
    color: #ff6b6b;
    border: 2px solid #ff6b6b;
    &:hover {
      background: rgba(255, 107, 107, 0.1);
    }
  `}
`;

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  return (
    <PageContainer>
      <ErrorCard>
        <Icon>
          <FontAwesomeIcon icon={faTimesCircle} />
        </Icon>
        <Title>Payment Failed</Title>
        <Subtitle>We couldn't process your payment</Subtitle>
        <Message>
          There was an issue processing your payment. Please check your payment details and try again.
          If the problem persists, please contact our support team.
        </Message>
        <ButtonGroup>
          <Button variant="primary" onClick={handleBackToHome}>
            Back to Home
          </Button>
        </ButtonGroup>
      </ErrorCard>
    </PageContainer>
  );
};

export default PaymentFailed; 